import {DrugItemDrawerMedicationProfilesSection} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {Tabs} from '@chakra-ui/react'

export function MedicationProfilesTab() {
  const {solutionDrug} = useSolutionDrugContext()

  return (
    <Tabs.Content value="medication-profiles">
      <DrugItemDrawerMedicationProfilesSection drugItem={solutionDrug} />
    </Tabs.Content>
  )
}
